'use client'
import { useGetProjectId } from '@/app/slugs'
import { queryKeys } from '@/shared/api/react-query'
import { toast } from '@/shared/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import useRefetchGet from './use-refetch-get'
import { UpdateHypothesis, hypothesisMappers } from '../../lib'
import services from '../services'

const useHook = () => {
  const mutationKey = [queryKeys((a, m, p) => a.hypothesis.update + m.get)]
  const queryClient = useQueryClient()
  const { projectId } = useGetProjectId()

  const { refetch } = useRefetchGet()

  const mutaion = useMutation({
    mutationKey,
    mutationFn: async (params: Partial<UpdateHypothesis>) =>
      await services.update(hypothesisMappers.mapUpdateHypothesisToDto(params)),
    onMutate: async () => {
      return undefined
    },
    onSuccess: async () => {
      toast({
        title: 'Вы успешно обновили гипотезу!',
      })

      if (projectId) {
        await queryClient.invalidateQueries({
          queryKey: ['board', +projectId],
          refetchType: 'active',
        })
        await queryClient.invalidateQueries({
          queryKey: ['hypothesis'],
          refetchType: 'active',
        })
      }

      refetch()
    },
  })

  useEffect(() => {
    if (mutaion.isError) console.error(mutaion.error)
  }, [mutaion.error, mutaion.isError])

  const muationResult = {
    ...mutaion,
    data: hypothesisMappers.mapUpdateHypothesis(mutaion?.data || {}),
  }

  return muationResult
}

export default useHook
